import { useMemo } from "react";

import { useCreateFolderMutation } from "@/graphql/folders/folders.hooks";
import { normalizeFolderName } from "@/utils/normalizeFolderName";

interface IUseCreateFolderOptions {
  onCompleted?: () => void;
  onError?: () => void;
}

interface IUseCreateFolderVariables {
  name: string;
}

const useCreateFolder = ({ onCompleted, onError }: IUseCreateFolderOptions) => {
  const [createFolder, { loading, error }] = useCreateFolderMutation({
    context: { errorType: "local" },
    onCompleted,
    onError,
  });

  return useMemo(
    () => ({
      createFolder: async ({ name }: IUseCreateFolderVariables) => {
        await createFolder({
          variables: {
            input: { name: normalizeFolderName(name) },
          },
        });
      },
      loading,
      error,
    }),
    [createFolder, error, loading]
  );
};

export default useCreateFolder;
